import dayjs from 'dayjs'

export function formatScheduleDate(date) {
    if (!date) return ''
    const parsed = dayjs(date, ['YYYY-MM-DD', 'DD.MM.YYYY'], true)
    return parsed.isValid() ? parsed.format('DD.MM.YYYY') : date
}

export function buildRangePickerValue(dateFrom, dateTo) {
    if (!dateFrom || !dateTo) return null

    return [
        dayjs(dateFrom, 'DD.MM.YYYY', true),
        dayjs(dateTo, 'DD.MM.YYYY', true),
    ]
}
